import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang, withLangPath, SUPPORTED_LANGS } from "@/i18n";
import { SITE_ORIGIN } from "@/data/site";

function upsertLink(hreflang, href) {
  const isCanonical = hreflang === "canonical";
  const selector = isCanonical ? 'link[rel="canonical"]' : `link[rel="alternate"][hreflang="${hreflang}"]`;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", isCanonical ? "canonical" : "alternate");
    if (!isCanonical) el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setMeta(attr, key, content) {
  const el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (el) el.setAttribute("content", content);
}

const OG_LOCALE = { it: "it_IT", en: "en_US", fr: "fr_FR", es: "es_ES" };

export function usePageMeta({ title, description }) {
  const { lang } = useLang();
  const location = useLocation();

  useEffect(() => {
    if (title) {
      document.title = title;
      setMeta("property", "og:title", title);
      setMeta("name", "twitter:title", title);
    }
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
  }, [title, description]);

  useEffect(() => {
    const path = location.pathname.replace(/\/+$/, "") || "/";
    const bare = withLangPath(path, "it");
    upsertLink("canonical", `${SITE_ORIGIN}${path}`);
    SUPPORTED_LANGS.forEach((l) => upsertLink(l, `${SITE_ORIGIN}${withLangPath(bare, l)}`));
    upsertLink("x-default", `${SITE_ORIGIN}${bare}`);
    setMeta("property", "og:url", `${SITE_ORIGIN}${path}`);
    setMeta("property", "og:locale", OG_LOCALE[lang]);
  }, [lang, location.pathname]);
}
